/* eslint-disable sonarjs/no-nested-template-literals */
import { Typography } from 'antd';
import styled, { css } from 'styled-components';
import { between } from 'polished';
import { FontTheme } from './constants';

// List of props : code , copyable , delete , disabled , editable , ellipsis , mark , keyboard , underline , onChange , strong , type

const JointStyling = css`
    &&& {
        display: ${({ display }) => display || ''};

        font-family: ${({ family }) => {
            if (!family) return FontTheme.Family.primary;
            switch (family) {
                case 'primary':
                    return FontTheme.Family.primary;
                case 'secondary':
                    return FontTheme.Family.secondary;
                default:
                    return family;
            }
        }};

        color: ${({ color }) => {
            if (!color) return FontTheme.Color.black;
            switch (color) {
                case 'black':
                    return FontTheme.Color.black;
                case 'light-black':
                    return FontTheme.Color.lightBlack;
                case 'dark-black':
                    return FontTheme.Color.darkBlack;
                case 'smoke':
                    return FontTheme.Color.smoke;
                case 'grey':
                    return FontTheme.Color.grey;
                case 'light':
                    return FontTheme.Color.light;
                case 'light-grey':
                    return FontTheme.Color.lightGrey;
                case 'link':
                    return FontTheme.Color.link;
                case 'blue':
                    return FontTheme.Color.blue;
                default:
                    return color;
            }
        }};

        font-weight: ${({ weight }) => {
            if (!weight) return FontTheme.Weight.regular;
            switch (weight) {
                case 'light':
                    return FontTheme.Weight.light;
                case 'regular':
                    return FontTheme.Weight.regular;
                case 'semi-bold':
                    return FontTheme.Weight.semiBold;
                case 'medium':
                    return FontTheme.Weight.medium;
                case 'bold':
                    return FontTheme.Weight.bold;
                case 'extra-bold':
                    return FontTheme.Weight.extraBold;
                default:
                    return weight;
            }
        }};

        font-size: ${({ size }) => {
            if (!size) return between('12px', FontTheme.Size.regular, '375px', '1920px');
            switch (size) {
                case 'tiny':
                    return FontTheme.Size.tiny;
                case 'regular':
                    return between('12px', FontTheme.Size.regular, '375px', '1920px');
                case 'noble-regular':
                    return between('12px', FontTheme.Size.nobleRegular, '375px', '1920px');
                case 'description':
                    return between('12px', FontTheme.Size.description, '375px', '1920px');
                case 'title':
                    return between('12px', FontTheme.Size.title, '375px', '1920px');
                case 'noble-title':
                    return between('12px', FontTheme.Size.nobleTitle, '375px', '1920px');
                case 'motto':
                    return between('12px', FontTheme.Size.motto, '375px', '1920px');
                case 'big-motto':
                    return between('32px', FontTheme.Size.bigMotto, '375px', '1920px');
                default:
                    return between('12px', size, '375px', '1920px');
            }
        }};

        font-style: ${({ fontStyle }) => {
            if (!fontStyle) return FontTheme.Style.normal;
            switch (fontStyle) {
                case 'normal':
                    return FontTheme.Style.normal;
                case 'italic':
                    return FontTheme.Style.italic;
                case 'oblique':
                    return FontTheme.Style.oblique;
                default:
                    return FontTheme.Style.normal;
            }
        }};

        max-width: ${({ maxWidth }) => {
            if (maxWidth) return maxWidth;
        }};

        ${({ disableselect }) =>
            disableselect &&
            `
                -webkit-touch-callout: none; 
                -webkit-user-select: none; 
                -khtml-user-select: none; 
                -moz-user-select: none; 
                -ms-user-select: none; 
                user-select: none; 
            `}

        letter-spacing: ${({ letterSpacing }) => {
            if (!letterSpacing) return 'none';
            switch (letterSpacing) {
                case 'middle':
                    return '0.5vw';
                case 'big':
                    return '1vw';
                case 'motto':
                    return between('15px', '160px', '375px', '1920px');
                default:
                    return letterSpacing;
            }
        }};

        line-height: ${({ lineheight }) => {
            if (!lineheight) return 'auto';

            return lineheight;
        }};
    }

    ${({ displayblock }) =>
        displayblock &&
        `
                display:block;
            `}
`;

export const Title = styled(Typography.Title)`
    ${JointStyling}
`;

export const Text = styled(Typography.Text)`
    ${JointStyling}
`;

export const Paragraph = styled(Typography.Paragraph)`
    ${JointStyling}
`;
